import { useSelector } from "react-redux";

const useMenuItems = () => {
  const auth = useSelector((state) => state?.authenticationSlice);
  const userTypeId = auth?.userTypeId;

  let menuItems = [];

  if (userTypeId === "5") {
    // Only OCR menu for userTypeId 5
    menuItems.push({
      label: "OCR",
      icon: "pi pi-home",
      items: [{ label: "Capture CNIC", icon: "pi pi-home", to: "/ocr" }],
    });
  } else {
    // Company menu for all other userTypes
    menuItems.push({
      label: "Company",
      icon: "pi pi-home",
      items: [
        {
          label: "View All Companies",
          icon: "pi pi-home",
          to: "/allcompanies",
        },
      ],
    });
  }

  return menuItems;
};

export default useMenuItems;
